export enum BREAKPOINTS {
  tiny = '480px',
  small = '576px',
  medium = '768px',
  large = '992px',
  extra_large = '1920px',
}
